module.exports = __webpack_public_path__ + "img/fire.611573b7.svg";